import ReportEditConfigController from '../ATReportEditConfigController'
import TTDetailsReportGroupingSelector from '../../TTDetailsReportGroupingSelector'
import $ from 'jquery'
import {ReportGroupingLevel} from '../../constants'
import ListSelector from '../../../controls/ListSelector'
import messageResource from '../../../messageResource'
import {formatLFM} from '../../../util/UserNameFormat'

export default class TTDetailReportEditConfigController extends ReportEditConfigController {}

TTDetailReportEditConfigController.groupingLevels = {
    NO_GROUPING : 0,
    ONE_LEVEL : 1,
    TWO_LEVELS : 2,
    THREE_LEVELS : 3
};

TTDetailReportEditConfigController.prototype.init = function ( config )
{
    ReportEditConfigController.prototype.init.call(this, config);

    this.reportAuthorizationInfo = config.reportAuthorizationInfo
    const reportParameters = this.makeReportParamsAccordingToFeatures(config.reportParameters);

    const self = this;
    this.configChangedCallback = config.changeCallback;
    const configChanged = function () { self.configChanged(); };

    this.timeFormatSelector = this.initListSelector("timeFormatSelect", reportParameters.timeFormat, configChanged);

    const groupingSelection = [reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel];

    this.groupingSelector = new TTDetailsReportGroupingSelector().init("reportGroupingSelector",
        groupingSelection,
        function() { 
            self.removeGroupingLevelsSelectionError();
            self.joinCommentsCheckbox.activate(self._checkIfNeedDisableJoinCommentsCheckbox());
            configChanged();});

    // init list selector
    this.numberOfGroupingLevelsSelector = this._initNumberOfGroupingLevelsListSelector(
        "numberOfGroupingLevelsSelect",
        this.groupingSelector.calculateNumberOfVisibleLevels(groupingSelection),
        function() {
            const numberOfGroupingLevels = self.numberOfGroupingLevelsSelector.getSelectedItem().value;
            self.groupingSelector.setNumberOfVisibleLevels(numberOfGroupingLevels);

            self.removeGroupingLevelsSelectionError();
            // change state of checkbox
            self.joinCommentsCheckbox.activate(self._checkIfNeedDisableJoinCommentsCheckbox() );
            configChanged();
        }
    );

    this.joinCommentsCheckbox = $("#joinComments");
    // disable checkbox or activate with previous value
    this.joinCommentsCheckbox.activate = function(isDisable){
        if (isDisable) {
            if (!this.prop("disabled")) {
                this.prevValue = this.prop("checked");
                this.prop("checked", false);
                this.prop("disabled", true );
            }
        } else {
            if (this.prop("disabled")) {
                this.prop("checked", this.prevValue);
            }
            this.prop("disabled", false );
        }
    };
    this.joinCommentsCheckbox.on("change", function(){
       configChanged();
    });
    // set value
    this.joinCommentsCheckbox.prop("checked", reportParameters.joinCommentsByTask);
    // than activate checkbox
    this.joinCommentsCheckbox.activate(this._checkIfNeedDisableJoinCommentsCheckbox());

    config.needAdditionalCheckbox = false;

    const $usernameLabel = $('.usernameLabel')
    let showUserSelector = this.reportAuthorizationInfo.anyOtherUsersAvailable || this.reportAuthorizationInfo.allUsersAvailable
    $usernameLabel.toggle(!showUserSelector)

    if (showUserSelector)
        this.userSelector = this.makeUserSelector({
            ...config,
            allUsersAvailable: this.reportAuthorizationInfo.allUsersAvailable
        });
    else {
        $('#userSelectorId').hide()
        const user = config.users[0]
        const usernameFormatted = formatLFM(user.firstName, user.lastName, user.middleName, ", ")
        $usernameLabel.text(usernameFormatted)
    }

    this.approvedTTFilter = this.addApprovedTTFilter(reportParameters.timeApprovalStatus, configChanged);

    this.cpSelector = this.makeCPSelector(reportParameters.customersProjectsSelection);

    return this;
};

/**
 * Return true if need disable join comments checkbox (if DAY && USER (disable  joinComments checkbox) or if n grouping levels = 0)
 * return  true if need disable or false otherwise
 * @returns {boolean|*}
 * @private
 */
TTDetailReportEditConfigController.prototype._checkIfNeedDisableJoinCommentsCheckbox = function() {
    const numberOfGroupingLevels = this.numberOfGroupingLevelsSelector.getValue();
    const values = this.groupingSelector.getValues(); // get grouping selection

    return numberOfGroupingLevels === TTDetailReportEditConfigController.groupingLevels.NO_GROUPING ||
        (this.checkGroupingLevel(ReportGroupingLevel.USER, values) && this.checkGroupingLevel(ReportGroupingLevel.DATE, values));
};

TTDetailReportEditConfigController.prototype._initNumberOfGroupingLevelsListSelector = function(id, selectedValue, onChangeCallback) {
    const numberOfGroupingLevelsSelector = new ListSelector({
        renderTo: $.find("#" + id)[0]
    });
    numberOfGroupingLevelsSelector.addItems(([
        {
            text :messageResource.getEscapedMessage("reports.comments_report.form.format.no_grouping"),
            value: TTDetailReportEditConfigController.groupingLevels.NO_GROUPING
        },
        {
            text :messageResource.getEscapedMessage("reports.comments_report.form.format.1_level"),
            value: TTDetailReportEditConfigController.groupingLevels.ONE_LEVEL
        },
        {
            text :messageResource.getEscapedMessage("reports.comments_report.form.format.2_levels"),
            value: TTDetailReportEditConfigController.groupingLevels.TWO_LEVELS
        },
        {
            text :messageResource.getEscapedMessage("reports.comments_report.form.format.3_levels"),
            value: TTDetailReportEditConfigController.groupingLevels.THREE_LEVELS
        }
    ]));

    numberOfGroupingLevelsSelector.on("change", onChangeCallback);

    numberOfGroupingLevelsSelector.setActiveItemByValue(selectedValue, true);

    return numberOfGroupingLevelsSelector;
};

TTDetailReportEditConfigController.prototype.getConfig = function () {
    const groupingLevelValues = this.groupingSelector.getValues();
    const needSwitchToMe = !this.reportAuthorizationInfo.anyOtherUsersAvailable && !this.reportAuthorizationInfo.allUsersAvailable
    return {
        timeFormat: this.timeFormatSelector.getValue(),
        joinCommentsByTask: this.joinCommentsCheckbox.prop("checked"),
        userSelection: this.userSelector ? this.userSelector.getSelection() : this.initReportParameters.userSelection,
        timeApprovalStatus: this.approvedTTFilter.getValue(),
        customersProjectsSelection: this.cpSelector.getCpSelection(),
        firstGroupingLevel: groupingLevelValues[0],
        secondGroupingLevel: groupingLevelValues[1],
        thirdGroupingLevel: groupingLevelValues[2],
        needSwitchToMe: needSwitchToMe,
    };
};

TTDetailReportEditConfigController.prototype.resetConfig = function () {
    const groupingSelection = [this.initReportParameters.firstGroupingLevel, this.initReportParameters.secondGroupingLevel, this.initReportParameters.thirdGroupingLevel];

    this.timeFormatSelector.setActiveItemByValue(this.initReportParameters.timeFormat, true);
    this.numberOfGroupingLevelsSelector.setActiveItemByValue(this.groupingSelector.calculateNumberOfVisibleLevels(groupingSelection), false);
    this.joinCommentsCheckbox.prop("checked", this.initReportParameters.joinCommentsByTask);

    if (this.userSelector) this.userSelector.setSelection(this.initReportParameters.userSelection);

    this.approvedTTFilter.setActiveItemByValue(this.initReportParameters.timeApprovalStatus, true);
    this.cpSelector.setSelection(this.initReportParameters.customersProjectsSelection);
    this.groupingSelector.setValues(groupingSelection);
};

TTDetailReportEditConfigController.prototype.validate = function()
{
    this.errors = [];

    if (this.userSelector && !this.userSelector.validateIsUserSelected())
        this.errors.push( this.possibleErrors.ERROR_EMPTY_USER_SELECTION );

    if (!this.cpSelector.checkSelected())
        this.errors.push( this.possibleErrors.ERROR_EMPTY_CP_SELECTION );

    if (!this.groupingSelector.validate())
        this.errors.push(this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR);

    return this.errors.length === 0;
};

TTDetailReportEditConfigController.prototype.initErrorsToSectionElsMap = function()
{
    const errorsToSectionElsMap = {};
    errorsToSectionElsMap[this.possibleErrors.ERROR_EMPTY_USER_SELECTION] = this.panelEl.find( "#userSelectorId" );
    errorsToSectionElsMap[this.possibleErrors.ERROR_EMPTY_CP_SELECTION] = this.panelEl.find( "#cpSelectorId" );
    errorsToSectionElsMap[this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR] = this.panelEl.find( ".dataGroupingControlContainer" );
    return errorsToSectionElsMap;
};

TTDetailReportEditConfigController.prototype.setSelectorsInitStateFromCurrent = function () {
    ReportEditConfigController.prototype.setSelectorsInitStateFromCurrent.call(this);

    if(this.userSelector){
        this.userSelector.setInitialValueFromCurrent();
    }
    if(this.cpSelector) {
        this.cpSelector.setInitialValueFromCurrent();
    }
};


// WEBPACK FOOTER //
// ./web/js/reports/edit_config_controller/ttDetail/TTDetailReportEditConfigController.js